import React from 'react'
import { Loading } from '@myxplor/ui'
import { FormDisplayErrors, FormInputWrapper } from '@myxplor/forms'
import FormSelect from 'react-select'
import LocalAsyncStore from '../../../local-async-store'

const SelectStyles = {
  control: (base) => ({
    ...base,
    color: 'currentColor',
    border: 'none',
    backgroundColor: 'transparent',
    borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
    borderRadius: 'none'
  })
}

export const selectData = (data = []) =>
  data.map(({ id, name }) => ({ value: id, label: `${name} - ${id}` }))

const apiEndPoint = ({ record }) =>
  `/api/service-registrations/${record.gov_id}/reg-holder-matches`

export const SelectList = ({ reg_holders, onChange }) => {
  let { loading, data } = reg_holders

  if (loading) return <Loading>Loading matching Xplor Services</Loading>
  if (data.length === 0)
    return <FormDisplayErrors errors='No matching Xplor Services' />

  return (
    <FormInputWrapper name='services' label='Xplor services' required>
      <FormSelect
        id='services'
        label='Xplor services'
        onChange={({ value }) => onChange('reg_holder_id', value)}
        required
        options={selectData(data)}
        placeholder='Please select ...'
        styles={SelectStyles}
      />
    </FormInputWrapper>
  )
}

export default LocalAsyncStore('reg_holders', SelectList, apiEndPoint)



// WEBPACK FOOTER //
// ./src/providers-registrations/service-list/activate-action/select.js